import React, { useState, useEffect, useRef } from 'react';
import { getLocationCookie } from '../../helpers';
import MultiFieldSuggestions from '../../components/MultiFieldSuggestions';
import useOutsideClick from '../../../hooks/useClickOutside';

const SearchBox = props => {
  const {
    suggestionsControllers,
    controller,
    className,
    placeholder,
    locationCookieName,
    onInputChange = null,
    onSubmit = null,
    isAutocomplete = false,
    submitToController = true,
    allowEmptySearch = false,
    removeLastSearchValue = false
  } = props;
  const [state, setState] = useState(controller.state);
  const [suggestionSelected, setSuggestionSelected] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const isEnterKey = e => e.key === 'Enter';
  useEffect(() => {
    controller.subscribe(() => {
      setState(controller.state);
    });
    let initialInputValue =
      getLocationCookie(locationCookieName)?.LastSearchValue || '';
    if (removeLastSearchValue) initialInputValue = '';
    const initial = isAutocomplete ? initialInputValue : '';
    setInputValue(initial);
    if (onInputChange) onInputChange(initial);
  }, []);
  const [expanded, setExpanded] = useState(false);

  const handleSubmit = () => {
    if (!allowEmptySearch && state.value === '') return;
    if (submitToController) controller.submit();
    if (onSubmit) onSubmit(controller.state.value);
  };

  const handleSuggestionClick = suggestion => {
    if (onInputChange) onInputChange(suggestion);
    controller.updateText(suggestion);
    setSuggestionSelected(true);
    setInputValue(suggestion);
  };

  const ref = useOutsideClick(() => {
    setExpanded(false);
  });

  return (
    <div className={className} ref={ref}>
      <input
        type="text"
        value={inputValue}
        onChange={e => {
          setInputValue(e.target.value);
          if (!expanded) setExpanded(true);
          if (onInputChange) onInputChange(e.target.value);
          setSuggestionSelected(false);
          controller.updateText(e.target.value);
        }}
        onKeyDown={e => isEnterKey(e) && handleSubmit()}
        placeholder={placeholder}
      />
      {suggestionsControllers?.length > 0 && !suggestionSelected && expanded && (
        <>
          <MultiFieldSuggestions
            controllers={[...suggestionsControllers]}
            text={state.value}
            onSuggestionClick={handleSuggestionClick}
          />
        </>
      )}
    </div>
  );
};

export default SearchBox;
